/**
 * Plugin Name: LT Analytics
 * Description: a plugin to include tracking analytics on lendingtree.com
 */

// ==================================Track-visit============================================================
const LtTrackingConfig = LT_TRACKING_CONFIG; // eslint-disable-line

if (window.ltanalytics) {
    window.ltanalytics.page(location.pathname, {
        path: location.pathname,
        isNonProd: LtTrackingConfig.ltanalyticsIsNonprod,
        isAuthenticated: (function (k) { return new RegExp(`(^|; )${k}=([^;]*)`).test(document.cookie); }('ajs_is_fcs')),
        isFreeCreditScore: (function (k) { return (document.cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2]; }('ajs_is_fcs')) || '',
        pageTemplate: LtTrackingConfig.pageTemplate,
    });
}

// ==================================Track-visit-end============================================================


// WEBPACK FOOTER //
// ./scripts/analytics-tracking.js